import { Flow_0_0_2 } from '@flexus/core';

export const SIL_1: Flow_0_0_2 = {
	id: '1',
	name: 'claim_submitted',
	itemType: 'flow',
	header: {
		title: 'Claim Submitted',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
